export default __webpack_public_path__ + "static/7 - interview questions for UX designer-ca091496a38ecc16053bb67b22e22b80.png";